declare namespace $ {

	type $shm_hitalama_vk_token_view__token_shm_hitalama_vk_token_switch_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_switch['token'] >
		,
		ReturnType< $shm_hitalama_vk_token_view['token'] >
	>
	type $mol_switch__value_shm_hitalama_vk_token_switch_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_switch['current_link'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__keys_shm_hitalama_vk_token_switch_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_switch['tokens_links'] >
		,
		ReturnType< $mol_switch['keys'] >
	>
	type $mol_switch__option_label_shm_hitalama_vk_token_switch_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_switch['option_label'] >
		,
		ReturnType< $mol_switch['option_label'] >
	>
	type $mol_button_minor__title_shm_hitalama_vk_token_switch_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_link__title_shm_hitalama_vk_token_switch_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__target_shm_hitalama_vk_token_switch_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__uri_shm_hitalama_vk_token_switch_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_switch['vk_auth_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_vk_token_switch_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_switch['Add_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_vk_token_switch_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_vk_token_switch_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_vk_token_switch_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_switch['clear'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_vk_token_switch extends $mol_view {
		current_link( next?: string ): string
		tokens_links( ): readonly(string)[]
		token( id: any): $shm_hitalama_vk_token
		Token( id: any): $shm_hitalama_vk_token_view
		option_label( id: any): readonly(any)[]
		Switch( ): $mol_switch
		Add_anchor( ): $mol_button_minor
		vk_auth_uri( ): string
		Add_vk( ): $mol_link
		Add( ): $mol_pop_over
		clear( next?: any ): any
		Clear( ): $mol_button_minor
		vk_token_url_parse( ): string
		tokens( ): readonly($shm_hitalama_vk_token)[]
		current( ): $shm_hitalama_vk_token | null
		sub( ): readonly(any)[]
		auto( ): readonly(any)[]
		vk_client_id( ): string
		vk_redirect_uri( ): string
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map